/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PermissionsQueryVariables = GraphQL.Exact<{ [key: string]: never; }>;


export type PermissionsQuery = { readonly __typename?: 'Query', readonly platformPermittedActionsForKingdomAdmin: ReadonlyArray<GraphQL.ActionWithPlatform> | null, readonly authenticatedSession: { readonly __typename?: 'AuthenticatedSession', readonly accounts: ReadonlyArray<{ readonly __typename?: 'Account', readonly id: CK.AccountId, readonly managedActions: ReadonlyArray<GraphQL.ActionWithAccount>, readonly managedActionsForKingdomAdmin: ReadonlyArray<GraphQL.ActionWithAccount>, readonly permittedActions: ReadonlyArray<GraphQL.ActionWithAccount>, readonly permittedActionsForKingdomAdmin: ReadonlyArray<GraphQL.ActionWithAccount> | null, readonly invitations: ReadonlyArray<{ readonly __typename?: 'Invitation', readonly id: CK.InvitationId, readonly managedActions: ReadonlyArray<GraphQL.ActionWithInvitation>, readonly managedActionsForKingdomAdmin: ReadonlyArray<GraphQL.ActionWithInvitation>, readonly permittedActions: ReadonlyArray<GraphQL.ActionWithInvitation>, readonly permittedActionsForKingdomAdmin: ReadonlyArray<GraphQL.ActionWithInvitation> | null }>, readonly memberships: ReadonlyArray<{ readonly __typename?: 'AccountMembership', readonly managedActions: ReadonlyArray<GraphQL.ActionWithAccountMembership>, readonly managedActionsForKingdomAdmin: ReadonlyArray<GraphQL.ActionWithAccountMembership>, readonly permittedActions: ReadonlyArray<GraphQL.ActionWithAccountMembership>, readonly permittedActionsForKingdomAdmin: ReadonlyArray<GraphQL.ActionWithAccountMembership> | null, readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId }, readonly user: { readonly __typename?: 'User', readonly id: string, readonly legacyId: string, readonly managedActions: ReadonlyArray<GraphQL.ActionWithUser>, readonly managedActionsForKingdomAdmin: ReadonlyArray<GraphQL.ActionWithUser>, readonly permittedActions: ReadonlyArray<GraphQL.ActionWithUser>, readonly permittedActionsForKingdomAdmin: ReadonlyArray<GraphQL.ActionWithUser> | null } }>, readonly websites: ReadonlyArray<{ readonly __typename?: 'Website', readonly id: CK.WebsiteId, readonly managedActions: ReadonlyArray<GraphQL.ActionWithWebsite>, readonly managedActionsForKingdomAdmin: ReadonlyArray<GraphQL.ActionWithWebsite>, readonly permittedActions: ReadonlyArray<GraphQL.ActionWithWebsite>, readonly permittedActionsForKingdomAdmin: ReadonlyArray<GraphQL.ActionWithWebsite> | null }> }> } | null };

export type UserWebsiteAccessPermissionsQueryVariables = GraphQL.Exact<{ [key: string]: never; }>;


export type UserWebsiteAccessPermissionsQuery = { readonly __typename?: 'Query', readonly authenticatedSession: { readonly __typename?: 'AuthenticatedSession', readonly accounts: ReadonlyArray<{ readonly __typename?: 'Account', readonly id: CK.AccountId, readonly memberships: ReadonlyArray<{ readonly __typename?: 'AccountMembership', readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId }, readonly user: { readonly __typename?: 'User', readonly id: string, readonly legacyId: string }, readonly websiteAccess: ReadonlyArray<{ readonly __typename?: 'UserWebsiteAccess', readonly id: CK.ID, readonly managedActions: ReadonlyArray<GraphQL.ActionWithUserWebsiteAccess>, readonly managedActionsForKingdomAdmin: ReadonlyArray<GraphQL.ActionWithUserWebsiteAccess>, readonly permittedActions: ReadonlyArray<GraphQL.ActionWithUserWebsiteAccess>, readonly permittedActionsForKingdomAdmin: ReadonlyArray<GraphQL.ActionWithUserWebsiteAccess> | null, readonly website: { readonly __typename?: 'Website', readonly id: CK.WebsiteId } }> }>, readonly websites: ReadonlyArray<{ readonly __typename?: 'Website', readonly id: CK.WebsiteId, readonly userAccess: ReadonlyArray<{ readonly __typename?: 'UserWebsiteAccess', readonly id: CK.ID, readonly managedActions: ReadonlyArray<GraphQL.ActionWithUserWebsiteAccess>, readonly managedActionsForKingdomAdmin: ReadonlyArray<GraphQL.ActionWithUserWebsiteAccess>, readonly permittedActions: ReadonlyArray<GraphQL.ActionWithUserWebsiteAccess>, readonly permittedActionsForKingdomAdmin: ReadonlyArray<GraphQL.ActionWithUserWebsiteAccess> | null, readonly user: { readonly __typename?: 'User', readonly id: string, readonly legacyId: string } }> }> }> } | null };


export const PermissionsDocument = gql`
    query Permissions {
  authenticatedSession {
    accounts {
      id
      invitations {
        id
        managedActions
        managedActionsForKingdomAdmin
        permittedActions
        permittedActionsForKingdomAdmin
      }
      managedActions
      managedActionsForKingdomAdmin
      memberships {
        account {
          id
        }
        managedActions
        managedActionsForKingdomAdmin
        permittedActions
        permittedActionsForKingdomAdmin
        user {
          id
          legacyId
          managedActions
          managedActionsForKingdomAdmin
          permittedActions
          permittedActionsForKingdomAdmin
        }
      }
      permittedActions
      permittedActionsForKingdomAdmin
      websites {
        id
        managedActions
        managedActionsForKingdomAdmin
        permittedActions
        permittedActionsForKingdomAdmin
      }
    }
  }
  platformPermittedActionsForKingdomAdmin
}
    `;

/**
 * __usePermissionsQuery__
 *
 * To run a query within a React component, call `usePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePermissionsQuery(baseOptions?: Apollo.QueryHookOptions<PermissionsQuery, PermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PermissionsQuery, PermissionsQueryVariables>(PermissionsDocument, options);
      }
export function usePermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PermissionsQuery, PermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PermissionsQuery, PermissionsQueryVariables>(PermissionsDocument, options);
        }
export function usePermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PermissionsQuery, PermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PermissionsQuery, PermissionsQueryVariables>(PermissionsDocument, options);
        }
export type PermissionsQueryHookResult = ReturnType<typeof usePermissionsQuery>;
export type PermissionsLazyQueryHookResult = ReturnType<typeof usePermissionsLazyQuery>;
export type PermissionsSuspenseQueryHookResult = ReturnType<typeof usePermissionsSuspenseQuery>;
export type PermissionsQueryResult = Apollo.QueryResult<PermissionsQuery, PermissionsQueryVariables>;
export const UserWebsiteAccessPermissionsDocument = gql`
    query UserWebsiteAccessPermissions {
  authenticatedSession {
    accounts {
      id
      memberships {
        account {
          id
        }
        user {
          id
          legacyId
        }
        websiteAccess {
          id
          managedActions
          managedActionsForKingdomAdmin
          permittedActions
          permittedActionsForKingdomAdmin
          website {
            id
          }
        }
      }
      websites {
        id
        userAccess {
          id
          managedActions
          managedActionsForKingdomAdmin
          permittedActions
          permittedActionsForKingdomAdmin
          user {
            id
            legacyId
          }
        }
      }
    }
  }
}
    `;

/**
 * __useUserWebsiteAccessPermissionsQuery__
 *
 * To run a query within a React component, call `useUserWebsiteAccessPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserWebsiteAccessPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserWebsiteAccessPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserWebsiteAccessPermissionsQuery(baseOptions?: Apollo.QueryHookOptions<UserWebsiteAccessPermissionsQuery, UserWebsiteAccessPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserWebsiteAccessPermissionsQuery, UserWebsiteAccessPermissionsQueryVariables>(UserWebsiteAccessPermissionsDocument, options);
      }
export function useUserWebsiteAccessPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserWebsiteAccessPermissionsQuery, UserWebsiteAccessPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserWebsiteAccessPermissionsQuery, UserWebsiteAccessPermissionsQueryVariables>(UserWebsiteAccessPermissionsDocument, options);
        }
export function useUserWebsiteAccessPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserWebsiteAccessPermissionsQuery, UserWebsiteAccessPermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserWebsiteAccessPermissionsQuery, UserWebsiteAccessPermissionsQueryVariables>(UserWebsiteAccessPermissionsDocument, options);
        }
export type UserWebsiteAccessPermissionsQueryHookResult = ReturnType<typeof useUserWebsiteAccessPermissionsQuery>;
export type UserWebsiteAccessPermissionsLazyQueryHookResult = ReturnType<typeof useUserWebsiteAccessPermissionsLazyQuery>;
export type UserWebsiteAccessPermissionsSuspenseQueryHookResult = ReturnType<typeof useUserWebsiteAccessPermissionsSuspenseQuery>;
export type UserWebsiteAccessPermissionsQueryResult = Apollo.QueryResult<UserWebsiteAccessPermissionsQuery, UserWebsiteAccessPermissionsQueryVariables>;